module.exports = __webpack_public_path__ + "media/signup-react/red-oval-01352877.png";